import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Amplify, { I18n } from 'aws-amplify';
import vocabularies from '@app/translations/vocabularies.json';
import awsExports from '@app/aws-exports';

import DmServicesContext from '@app/context/main/dmServicesContext';
import { Error404 } from '@app/common/Error/Error';
import Home from './modules/containers/Home/Home';
import Loader from './common/Loader/Loader';

I18n.putVocabularies(vocabularies);
Amplify.configure(awsExports);

export default function Root(props) {
  const [state, dispatch] = useContext(DmServicesContext);
  const [loading, setLoading] = useState(false);
  //Internacionalization
  const language = localStorage.getItem('currentAppLanguage');
  const [locale, setLocale] = useState(language);
  const customerData = state.customerData;

  useEffect(() => {
    window.addEventListener('currentCustomerAccountData:changed', (evt) => {
      dispatch({
        type: 'UPDATE_CUSTOMER_DATA',
        payload: evt.detail.customerData,
      });
    });
    return () => {
      window.removeEventListener(
        'currentCustomerAccountData:changed',
        (evt) => {}
      );
    };
  }, []);

  useEffect(() => {
    if (!state.customerData) {
      dispatch({
        type: 'UPDATE_CUSTOMER_DATA',
        payload: JSON.parse(localStorage.getItem('currentCustomerAccountData')),
      });
    }
  }, [state.customerData]);

  useEffect(() => {
    window.addEventListener('i18n:changed', (evt) => {
      if (evt.detail.language) {
        I18n.setLanguage(evt.detail.language);
        setLocale(evt.detail.language);
      }
    });
    return () => {
      window.removeEventListener('i18n:changed', (evt) => {
        if (evt.detail.language) {
          I18n.setLanguage(evt.detail.language);
        }
      });
    };
  }, []);

  useEffect(() => {
    Amplify.I18n.setLanguage(locale);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  const baseUrl = window.location.pathname.slice(1).split('/')[0];

  return (
    <BrowserRouter basename={baseUrl}>
      <Switch>
        {baseUrl === '' ? (
          customerData && !loading ? (
            <Home language={locale} customerData={customerData} />
          ) : (
            <Loader />
          )
        ) : (
          <Route render={(props) => <Error404 {...props} />} />
        )}
      </Switch>
    </BrowserRouter>
  );
}
